var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileSwitchLanguage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 20a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm14 0a5.997 5.997 0 0 1-2.945 5.165C23.645 23.772 24 21.97 24 20c0-1.969-.356-3.772-.945-5.165A5.997 5.997 0 0 1 26 20Zm-10 0c0-1.969.356-3.772.945-5.165A5.997 5.997 0 0 0 14 20a5.997 5.997 0 0 0 2.945 5.165C16.355 23.772 16 21.97 16 20Zm4.265 5.844c-.145.123-.225.156-.265.156-.04 0-.12-.033-.265-.156-.252-.212-.524-.58-.775-1.082C18.362 23.565 18 21.854 18 20c0-1.854.362-3.565.96-4.762.251-.502.523-.87.775-1.082.145-.123.225-.156.265-.156.04 0 .12.033.265.156.252.212.524.58.775 1.082.598 1.197.96 2.908.96 4.762 0 1.854-.362 3.565-.96 4.762-.251.502-.523.87-.775 1.082Z",
  fill: "#612FFF"
})));
export default SvgMobileSwitchLanguage;